import { styled } from 'stitches.config'

export const Title = styled('h1', {
  textAlign: 'center',
  fontSize: '$h3',
  lineHeight: '$h3',
  letterSpacing: '$h3',
  width: '100%',
  maxWidth: '890px',
  margin: 'auto',
  color: '$accent-white',

  '@bp2': {
    fontSize: '$h1',
    lineHeight: '$h1',
    letterSpacing: '$h1',
  },
})

export const BodyWrapper = styled('div', {
  marginTop: '$2',
  textAlign: 'center',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  gap: '$3',
  color: '$accent-white',
  '@bp2': {
    marginTop: '$4',
    textAlign: 'left',
  },
})

export const ButtonWrapper = styled('div', {
  marginTop: '$2',
  textAlign: 'center',
  '@bp2': {
    marginTop: '$4',
  },
  '& a.cta': {
    display: 'inline'
  }
})